import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Colors from "../../../ui/global/Colors";
import Fonts from "../../../ui/global/Fonts";
import TopBar from "../../website/TopBar";
import Hero from "../../website/Hero";
import ArtGallery from "../components/ArtGallery";
import RainbowButton from "../../website/RainbowButton";
import Button from "../../../ui/components/Button";
import { ArtType } from "../Art";
import CursorEffect from "../../../ui/components/CursorEffect";
import Footer from "../../website/Footer";
import GlobalMessage from "../../pricing/GlobalMessage";

const Root = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100svh;
    background-color: ${Colors.background};
    color: ${Colors.black};
    padding: 5px 5px 0 5px;
    // margin-top: 54px;
    gap: 10px;
    overflow-x: visible;
    overflow-y: auto;
`;

const InitialContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    text-align: center;
    margin: 0;
    margin-bottom: 40px;
    gap: 20px;
    overflow: visible;
`;

const InitialButtonContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin: 10px;
    margin-top: 30px;
    gap: 10px;
    z-index: 2;

    @media (max-width: 412px) {
        flex-direction: column;
        width: 100%;
        gap: 20px;
    }
`;

interface ArtInitialProps {
    config: any;
    onCreateClick: (artType: ArtType) => void;
}

const ArtInitial = ({ config, onCreateClick }: ArtInitialProps) => {
    
    const primaryButtons = (
        <InitialButtonContainer>
            <RainbowButton color='black' text="Create 2D" onClick={() => onCreateClick('2D')} />
            <Button size='large' color='white' text="Create 3D" onClick={() => onCreateClick('3D')} />
        </InitialButtonContainer>
    );

    const tabs = [
        { name: 'My Art' },
        { name: 'Community' },
    ];

    return (
        <Root id="art-initial-root">
            <GlobalMessage config={config} colorMode="light" />
            <TopBar type={'Art'} colorMode='light'/>
            <InitialContainer>
                <Hero 
                    title="AI Art" 
                    subtitle="Simple sketch to beautiful art." 
                    colorMode='light'
                    children={primaryButtons} 
                />
                <ArtGallery colormode="light" tabs={tabs} />
                <CursorEffect colorMode="light"/>
            </InitialContainer>
            <Footer colorMode='light'/>
        </Root>
    );
};

export default ArtInitial;